module.exports = __webpack_public_path__ + "img/banner.66d0d7e.jpg";